import React from 'react';
import Heading2 from '@Components/heading_2/view';

import s from '../styles/DetailContent.module.css';

const Knowledge35 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の贈与（生前贈与時の評価・注意点）' fontWeight={700} />
                <p>
                    ゴルフ会員権は、相続だけでなく生前贈与によって次の世代へ引き継ぐことも可能です。
                    <br />
                    ただし、相続と異なり贈与には贈与税が課される可能性があり、評価方法や税額の計算、名義書換の手続きなど、事前に押さえておくべきポイントがいくつかあります。本記事では、ゴルフ会員権を生前贈与する際の評価方法と注意点を解説します。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='贈与時の評価方法は相続税評価と同じ' fontWeight={700} />
                <p>
                    贈与税の計算に用いる財産の評価は、相続税と同じく財産評価基本通達に基づいて行います。ゴルフ会員権についても、
                    <a href='/knowledge/34'>ゴルフ会員権の相続税評価・計算方法（具体例つき）</a>
                    でご紹介した評価方法（取引相場のある会員権は取引価格の70％相当額＋預託金等、取引相場のない会員権は非上場株式評価や預託金等の評価額）がそのまま適用されます。
                    <br />
                    評価基準日は「贈与を受けた日（名義書換等により実際に権利が移転した日）」の時価となるため、相続の場合の「相続開始日」と基準日が異なる点に注意してください。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='暦年課税での贈与税額の考え方' fontWeight={700} />
                <p>
                    個人から個人への贈与には、原則として暦年課税が適用されます。1年間（1月1日～12月31日）に受け取った贈与財産の合計額から基礎控除110万円を差し引いた金額に、贈与税の税率を掛けて税額を計算します。
                    <br />
                    税率は、直系尊属（父母・祖父母など）から18歳以上の子・孫が受ける贈与に適用される「特例税率」と、それ以外の贈与に適用される「一般税率」の2種類があり、同じ評価額でも特例税率の方が税負担は軽くなる設計になっています。ゴルフ会員権の評価額が高額になりやすいクラブでは、贈与税額も相応に高額になる可能性があるため、事前のシミュレーションが欠かせません。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='相続時精算課税制度を選択する場合' fontWeight={700} />
                <p>
                    60歳以上の父母・祖父母から18歳以上の子・孫への贈与については、暦年課税に代えて相続時精算課税制度を選択することもできます。
                    <br />
                    相続時精算課税を選択すると、年間110万円の基礎控除に加えて、累計2,500万円までの特別控除の範囲内であれば贈与税がかからず（超えた部分は一律20％課税）、贈与した財産は将来の相続時に相続財産へ合算して精算する仕組みになります。
                    <br />
                    高額なゴルフ会員権を早期に後継者へ移転したい場合に選択肢となりますが、一度選択すると同じ贈与者からの贈与について暦年課税へ戻せないなど制約もあるため、税理士に相談のうえで判断することをおすすめします。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='贈与時に必要な名義書換の手続き' fontWeight={700} />
                <p>
                    ゴルフ会員権を贈与する場合も、相続と同様にゴルフ場への名義書換の手続きが必要です。贈与を原因とする名義書換では、贈与契約書や戸籍関係の書類、ゴルフ場所定の申請書などの提出を求められるのが一般的です。
                    <br />
                    名義書換料が発生するかどうか、金額がいくらになるかはゴルフ場ごとに異なるため、事前にゴルフ場または会員権業者へ確認しておきましょう。名義書換料の勘定科目や仕訳については
                    <a href='/knowledge/36'>名義書換料の勘定科目・仕訳完全ガイド</a>
                    で詳しく解説しています。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='贈与を検討する際の注意点' fontWeight={700} />
                <p>
                    ゴルフ会員権は、預託金の据置期間や入会審査の有無など、現金や上場株式の贈与とは異なる固有の事情があります。贈与を受ける側が入会審査に通らない、あるいはそのゴルフ場に法人会員制度がなく個人でしか入会できないなど、想定外の制約に直面することもあります。
                    <br />
                    また、贈与するタイミングによって評価額（取引相場）が変動するため、相場が下がっている時期を選ぶことで贈与税の負担を抑えられる可能性がある一方、将来的な資産価値の見通しも踏まえた総合的な判断が必要です。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                <p>
                    ゴルフ会員権の生前贈与は、評価方法こそ相続税評価と共通していますが、税率や控除の仕組みは贈与税特有のものになるため、暦年課税と相続時精算課税のどちらが有利かを事前に比較しておくことが大切です。
                    <br />
                    評価額の算定や税額のシミュレーションは税理士に、名義書換や贈与に伴うゴルフ会員権の手続き全般は住地ゴルフまでお気軽にご相談ください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge35;
